import { useEffect, useState } from "react";
import { fetchSeoCms } from "./cms";

// Merges a published CMS SEO override (if any) over page-coded defaults.
// Falls back silently to defaults if CMS is empty/unavailable — never blocks render.
export function useCmsSeo(pageKey, defaults) {
  const [merged, setMerged] = useState(defaults);

  useEffect(() => {
    let alive = true;
    fetchSeoCms(pageKey).then((override) => {
      if (!alive) return;
      if (!override || Object.keys(override).length === 0) {
        setMerged(defaults);
        return;
      }
      setMerged({
        ...defaults,
        title: override.title || defaults.title,
        description: override.description || defaults.description,
        keywords: override.keywords || defaults.keywords,
        ogImage: override.og_image || defaults.ogImage,
        canonical: override.canonical || defaults.canonical,
        noindex: typeof override.noindex === "boolean" ? override.noindex : defaults.noindex,
      });
    });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageKey]);

  return merged;
}
